import Vue from 'vue';
import Router from 'vue-router';
import EntryList from '../components/administration/EntryList';
import Login from '../components/login/Login';
import Register from '../components/login/Register';
import Instructions from '../components/instructions/Instructions';
import Map from '../components/map/Map';
import MapIntroduction from '../components/map/MapIntroduction';
import Table from '../components/Table';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            components: {
                default: MapIntroduction,
                content: Map
            },
        },
        {
            path: '/instruction',
            component: Instructions,
        },
        {
            path: '/table',
            components: {
                default: MapIntroduction,
                content: Table
            },
        },
        {
            path: '/login',
            component: Login,
        },
        {
            path: '/register',
            component: Register,
        },

        {
            path: '/admin',
            components: {
                default: EntryList
            },
        }
    ],
});
